module.exports = __webpack_public_path__ + "static/media/img156.f0efd5ba.jpg";